import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { InsertEmoticon } from '@material-ui/icons'
import {
  IconButton,
  withStyles,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
} from '@material-ui/core'
import Picker from 'emoji-picker-react'

class EmojiMenu extends Component {
  state = { open: false }

  handleToggle = (event) => {
    this.setState((state) => ({ open: !state.open }))
  }

  handleClose = (event) => {
    if (this.anchorEl.contains(event.target)) {
      return
    }

    this.setState({ open: false })
  }

  onEmojiClick = (event, emojiObject) => {
    // console.log(emojiObject)
    if (emojiObject && emojiObject.emoji && this.props.onEmojiClick) {
      this.props.onEmojiClick(emojiObject.emoji)
      this.setState({open: false})
    }
  }

  render() {
    const {
      messageType,
      conversationSelected,
      contactSelected,
      classes,
      disabled,
      disableAutoFocus,
    } = this.props
    const { open } = this.state

    return (
      <Fragment>
        <IconButton
          buttonRef={(node) => {
            this.anchorEl = node
          }}
          onMouseDown={(e) => e.preventDefault()}
          onPointerDown={(e) => e.preventDefault()}
          classes={{ root: classes.root }}
          style={
            messageType === 'text'
              ? { position: 'absolute', left: 2, marginTop: 8 }
              : { margin: '0 5px' }
          }
          variant="outlined"
          size="small"
          aria-owns={open ? 'simple-menu' : undefined}
          aria-haspopup="true"
          onClick={this.handleToggle}
          disabled={disabled || (!conversationSelected && !contactSelected)}
        >
          <InsertEmoticon />
        </IconButton>
        <Popper style={{ zIndex: 999, marginTop: messageType === 'text' ? -300 : 'auto'  }} open={open} anchorEl={this.anchorEl} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="menu-list-grow"
              style={{
                transformOrigin:
                  'center top'//placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={this.handleClose}>
                  <Picker
                    preload
                    disableAutoFocus={disableAutoFocus}
                    onEmojiClick={this.onEmojiClick}
                  />
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Fragment>
    )
  }
}

const styles = (theme) => ({
  root: {
    padding: 3,
  },
})

export default connect(
  (state) => ({
    messageType: state.inbox.to.current.type,
    conversationSelected: state.inbox.conversationSelected,
    contactSelected: state.inbox.contactSelected,
  }),
  null,
)(withStyles(styles)(EmojiMenu))
